<template>
  <div id="impact-project" class="impact-container" v-if="products">
    <Card class="main-card" :product="products[0]" wide></Card>
    <div class="cards-wrapper">
      <Card v-for="(item, index) in products.slice(1)" :key="index" :product="item"></Card>
    </div>
  </div>
</template>

<script>
import Card from "./Card.vue";

export default {
  name: "ImpactProject",
  components: {
    Card
  },

  data() {
    return {
      products: null
    };
  },
  props: {
    productIds: {
      type: Array,
      required: true,
    },
  },

  async created() {
    try {
      const data = await this.$store.dispatch("getProductsByIds", this.productIds);
      const metaProjects = [];

      data.forEach(product => {
        const meta = product && product.meta;
        if (meta && meta.projectTitle && meta.dueDate && (typeof meta.goalAmount === "number")) {
          metaProjects.push({ ...product.meta });
        }
      });

      this.products = metaProjects;
    } catch (err) {
      console.error(err);
    }
  }
};
</script>

<style scoped>
.impact-container {
  --cardsSpacing: 0.8rem;
}

.cards-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--cardsSpacing);
}

.main-card {
  margin-bottom: var(--cardsSpacing);
}

@media only screen and (min-width: 1200px) {
  .impact-container {
    --cardsSpacing: 2rem;
  }
}
</style>


// WEBPACK FOOTER //
// ImpactProject.vue?4d0304c1